export class GenericQueryError extends Error {
  constructor(message: string) {
    super(message)

    this.name = 'GenericQueryError'
  }
}
